<template>
	<div class="position-relative pb-3">
    <div class="rounded-6 bg-white box-shadow-light-aff mb-3 mt-2">
      <div class="px-3">
        <div class="row no-gutters py-2">
          <div class="col-12 align-self-center">
            <img :src="data.merchant.image_url" class="img-hotel mr-3 rounded-6 object-fit d-inline-block align-middle">
            <div class="d-inline-block align-middle concierge-menu-top-wrapper">
              <div class="mb-1">
                <p class="mb-0 body-2-2 font-bold text-truncate">{{data.merchant.name}}</p>
                <template v-if="show_room">
                  <p class="mb-0 body-3-3 font-bold" :class="{
                    'text-danger': data.room_type == 'Unallocated Room Type'
                  }">{{ data.room_type }}</p>
                  <!-- <p class="mb-0 body-3-3 font-semibold">{{data.room}}</p> -->
                </template>
                <template v-else>
                  <p class="mb-0 body-3-3 font-bold">{{formatDate(data.detail.check_in)}} - {{formatDate(data.detail.check_out)}}</p>
                  <p class="mb-0 body-3-3 font-semibold">{{data.total_rooms}} Room{{data.total_rooms > 1 ? 's' : ''}}</p>
                </template>
              </div>
              <!-- <div class="bg-green rounded-4 cursor-pointer px-2 py-1 d-table">
                <p class="mb-0 text-white body-3-3 font-semibold">Print Bill</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="py-2 border-top px-3 cursor-pointer" @click="is_detail = !is_detail">
        <div class="row no-gutters">
          <div class="col-10 align-self-center">
            <p class="mb-0 body-3-3 text-green">{{$t('hotel.concierge.reservation-detail')}}</p>
          </div>
          <div class="col-2 align-self-center text-right">
            <i :class="{'simple-icon-arrow-up' : is_detail, 'simple-icon-arrow-down' : !is_detail}" class="text-green text-12"></i>
          </div>
        </div>
      </div>
      <!-- <div class="row slim-grid-row position-relative cursor-pointer">
        <div class="col-4 col-md-3">
          <div class="w-55px mx-auto">
            <img :src="data.merchant.image_url" class="img-fit">
          </div>
        </div>
        <div class="col-8 col-md-9">
          <p class="mb-0 body-1-4 text-16">{{data.merchant.name}}</p>
          <p v-if="data.total_rooms > 0" class="mb-0 body-2 text-12">{{data.total_rooms}} Room{{data.total_rooms > 1 ? 's' : ''}}</p>
          <p class="mb-0 body-2 text-12 text-truncate" v-if="!is_detail">{{formatDate(data.detail.check_in)}} - {{formatDate(data.detail.check_out)}}</p>
        </div>
        <i class="simple-icon-arrow-up position-absolute m-2" style="right: 0" v-if="is_detail"></i>
        <i class="simple-icon-arrow-down position-absolute m-2" style="right: 0" v-else></i>
      </div> -->
    </div>
    <div v-if="is_detail" class="rounded-6 bg-white box-shadow-bold p-3">
      <p class="mb-2 body-2-2 text-14 font-bold">{{$t('hotel.concierge.reservation-detail')}}</p>
      <div class="row">
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.checkin')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{formatDate(data.detail.check_in)}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.checkout')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{formatDate(data.detail.check_out)}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.room-type.room-type')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{data.room_type}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.room')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{data.room}}</p>
        </div>
        <div class="col-6 mb-2" v-if="$isNotEmptyV2(getMerchant.precheckin_form_header_show_rate)">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.rate')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{data.rate}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.guest')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{guest}}</p>
        </div>
      </div>
      <p class="mt-3 mb-2 body-2-2 text-14 font-bold">{{$t('hotel.concierge.contact-details')}}</p>
      <div class="row">
        <div class="col-12 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.form.name')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{data.guest.name}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.form.email')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold text-truncate">{{data.guest.email == null ? '-': data.guest.email}}</p>
        </div>
        <div class="col-6 mb-2">
          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.concierge.form.phone-number')}}</p>
          <p class="mb-0 body-2-2 text-12 font-semibold">{{data.guest.phone == null ? '-': data.guest.phone}}</p>
        </div>
      </div>
      <p class="mt-3 mb-2 body-2-2 text-14 font-bold">{{$t('hotel.concierge.special-request')}}</p>
      <div class="row">
        <div class="col-12 mb-2">
          <div class="row">
            <div class="col-12">
              <p class="mb-0 body-2-2 text-12 font-semibold d-inline-block w-75 align-top">{{data.detail.special_request}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {formatDate} from '@/utils/index.js'
  import { mapGetters } from 'vuex';

	export default{
		props: ['data','show_room'],
		data(){
			return{
				is_detail: false
			}
		},
    computed:{
      ...mapGetters(['getMerchant']),
      guest(){
        let display= `${this.data.detail.adult} ${this.$t('hotel.concierge.adult')}`
        if(this.data.detail.child > 0){
          display += (`, ${this.data.detail.child} ${this.$t('hotel.concierge.child')}`)
        }
        return display;
      }
    },
    methods:{
      formatDate(date){
        return formatDate(date);
      }
    }
	}
</script>
<style scoped>
  .img-hotel{
    width: 75px;
    height: 75px;
  }

  .concierge-menu-top-wrapper{
    width:  70% !important;
  }

  @media screen and (min-width: 992px){
    .img-hotel{
      width: 50px;
      height: 50px;
    }
  }

  @media screen and (max-width: 768px){
    .concierge-menu-top-wrapper{
      width:  63% !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/CheckinData.vue